import { Component } from '@angular/core';
import { TitleService } from '../../../services/title.service';

@Component({
    selector: 'app-sala-pesi',
    imports: [],
    templateUrl: './sala-pesi.component.html',
    styleUrl: './sala-pesi.component.css'
})
export class SalaPesiComponent {
  constructor(private ts : TitleService) {  }

  ngOnInit(){
    this.ts.titolo = "Sala pesi";
  }
}
